import type { DefaultOptionType } from "antd/es/select";
import {
  customerType,
  jobType,
  orderType,
} from "../Types/invoiceManagementTypes";
import { RolesMetaDataResponseType } from "../Types/DatabaseTabTypes";
import React from "react";

export const getJobDropdownOptions = (data?: any[]) => {
  return data?.map((item: any) => ({
    label: item.label,
    value: item.id,
    key: item.id,
  }));
};

export const getDropdownOptions = (data?: any[]) => {
  return data?.map((item: any) => ({
    label: item.companyName,
    value: item.id,
    key: item?.id,
  }));
};
export const getContactDropdownOptions = (data?: any[]) => {
  return data?.map((item: any) => ({
    label: `${item.firstName} ${item.lastName}`,
    value: item.id,
    key: item?.id,
  }));
};
export const getSalesPersonDropdownOptions = (data?: any[]) => {
  return data?.map((item: any) => ({
    label: item?.name,
    value: item?.id,
    key: item?.id,
  }));
};

export const getQuarrayLocationsDropdownOptions = (data: any[]) => {
  return data?.map((item: any) => ({
    label: item?.quarryName,
    value: item?.id,
    key: item?.id,
  }));
};
export const getSendContactDropdownOptions = (data?: any[]) => {
  return data?.map((item: any) => ({
    label: (
      <span>
        <span style={{ color: "black" }}>
          {item.firstName} {item.lastName}
        </span>
        <span style={{ color: "#1890FF" }}> {item.email}</span>
      </span>
    ),
    value: item.id,
    key: item?.id,
  }));
};

export const getDropdownOptionsCustomLabel = (
  data?: any[],
  renderLabel: (item: any) => React.ReactNode,
) => {
  return data?.map((item: any) => {
    const searchText = `${item?.firstName} ${item?.lastName} ${item?.email ?? item?.phone ?? ""}`;
    return {
      label: renderLabel ? renderLabel(item) : item?.label,
      value: item.id,
      key: item?.id,
      children: searchText,
    };
  });
};

export function enumToLabelValueArray<T extends Record<string, string>>(
  enumObj: T,
) {
  return Object.values(enumObj).map((value) => ({
    label: value,
    value,
    key: value,
  }));
}

//Overloads - Can be added in future for any id, name pairs
function toLabelValueArray(arr: customerType[]): DefaultOptionType[];
function toLabelValueArray(arr: jobType[]): DefaultOptionType[];
function toLabelValueArray(arr: orderType[]): DefaultOptionType[];
function toLabelValueArray(
  arr: RolesMetaDataResponseType[],
): DefaultOptionType[];

export function toLabelValueArray(
  arr: customerType[] | jobType[] | orderType[] | RolesMetaDataResponseType[],
): DefaultOptionType[] {
  return arr.map((item: any) => {
    if ("companyId" in item && "companyName" in item) {
      return {
        label: item.companyName ?? "",
        value: item.companyId ?? "",
        key: item?.companyId,
      };
    }
    if ("jobId" in item && "jobName" in item) {
      return {
        label: item.jobName ?? "",
        value: item.jobId ?? "",
        key: item?.jobId,
      };
    }
    if ("orderId" in item && "order" in item) {
      return {
        label: item.order ?? "",
        value: item.orderId ?? "",
        key: item?.orderId,
      };
    }
    if ("roleName" in item && "id" in item) {
      return {
        label: item.roleName ?? "",
        value: item.id ?? "",
        key: item?.id,
      };
    }
    return { label: "", value: "" };
  });
}

//Enum to antd select options
export const getEnumOptions = (enumObject: object): DefaultOptionType[] => {
  return Object.values(enumObject).map((value) => ({
    label: value as string,
    value: value as string,
    key: value as string,
  }));
};

//Array to andt options
export function arrayToOptions(arr: number[] | string[]): DefaultOptionType[] {
  const filteredArr = arr.filter(
    (val) => val !== null && val !== undefined && val !== "",
  );
  const uniqueArr = Array.from(new Set(filteredArr));
  return uniqueArr.map((val) => ({
    label: String(val),
    value: val,
    key: val,
  }));
}

//Filter out search value in antd option
export const getFilteredOptions = (
  options: SelectProps["options"],
  searchValue,
) =>
  options?.filter((option) => {
    if (option?.label) {
      return option?.label
        ?.toString()
        ?.toLowerCase()
        ?.includes(searchValue?.toLowerCase());
    }
    return false;
  });

export const getMaterialCategoriesDropdownOptions = (data: any[]) => {
  if (!data) return [];
  return data?.map((item: any) => ({
    label: item?.category,
    value: item?.category,
    key: item?.category,
  }));
};

export const getMaterialTypeDropdownOptions = (data: any[]) => {
  if (!data) return [];
  return data?.map((item: any) => ({
    label: item?.subCategory,
    value: item?.subCategory,
    key: item?.subCategory,
  }));
};

export const getMaterialNameOptions = (data: any[]) => {
  if (!data) return [];
  return data?.map((item: any) => ({
    label: item?.label,
    value: item?.label,
    key: item?.label,
  }));
};
